import request from "@/utils/request";
import Qs from "qs";

// 综合态势
// 云州-综合态势-园区信息配置-编辑
export function yzZhParkInfoEdit(data) {
  return request({
    url: "/yunzhou/zhts_parkinfo_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-综合态势-园区信息配置-详情
export function yzZhParkInfoDetail(data) {
  return request({
    url: "/yunzhou/zhts_parkinfo_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-综合态势-重点项目宣传-新增
export function yzZhProjectAdd(data) {
  return request({
    url: "/yunzhou/zhts_project_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-综合态势-重点项目宣传-删除
export function yzZhProjectDel(data) {
  return request({
    url: "/yunzhou/zhts_project_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-综合态势-重点项目宣传-编辑
export function yzZhProjectEdit(data) {
  return request({
    url: "/yunzhou/zhts_project_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-综合态势-重点项目宣传-详情
export function yzZhProjectDetail(data) {
  return request({
    url: "/yunzhou/zhts_project_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-综合态势-重点项目宣传-列表
export function yzZhProjectList(data) {
  return request({
    url: "/yunzhou/zhts_project_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-综合态势-能耗概括-新增
export function yzZhEnergyAdd(data) {
  return request({
    url: "/yunzhou/zhts_energy_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-综合态势-能耗概括-编辑
export function yzZhEnergyEdit(data) {
  return request({
    url: "/yunzhou/zhts_energy_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-综合态势-能耗概括-删除
export function yzZhEnergyDel(data) {
  return request({
    url: "/yunzhou/zhts_energy_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-综合态势-能耗概括-详情
export function yzZhEnergyDetail(data) {
  return request({
    url: "/yunzhou/zhts_energy_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-综合态势-能耗概括-列表
export function yzZhEnergyList(data) {
  return request({
    url: "/yunzhou/zhts_energy_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 智慧运营
// 云州-智慧运营-活动展示-新增
export function yzYYActivityAdd(data) {
  return request({
    url: "/yunzhou/zhyy_activity_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-活动展示-编辑
export function yzYYActivityEdit(data) {
  return request({
    url: "/yunzhou/zhyy_activity_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-活动展示-删除
export function yzYYActivityDel(data) {
  return request({
    url: "/yunzhou/zhyy_activity_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-活动展示-详情
export function yzYYActivityDetail(data) {
  return request({
    url: "/yunzhou/zhyy_activity_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-活动展示-列表
export function yzYYActivityList(data) {
  return request({
    url: "/yunzhou/zhyy_activity_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-智慧运营-各项配置-编辑
export function yzYYConfigEdit(data) {
  return request({
    url: "/yunzhou/zhyy_config_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-智慧运营-各项配置-详情
export function yzYYConfigDetail(data) {
  return request({
    url: "/yunzhou/zhyy_config_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 云州-智慧运营-满意度调查-新增
export function yzYYSatisfyAdd(data) {
  return request({
    url: "/yunzhou/service_comment_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-满意度调查-编辑
export function yzYYSatisfyEdit(data) {
  return request({
    url: "/yunzhou/service_comment_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-满意度调查-删除
export function yzYYSatisfyDel(data) {
  return request({
    url: "/yunzhou/service_comment_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-满意度调查-详情
export function yzYYSatisfyDetail(data) {
  return request({
    url: "/yunzhou/service_comment_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧运营-满意度调查-列表
export function yzYYSatisfyList(data) {
  return request({
    url: "/yunzhou/service_comment_list",
    method: "post",
    data: Qs.stringify(data),
  });
}






// 云州-智慧经营-各项配置-编辑
export function yzJYConfigEdit(data) {
  return request({
    url: "/yunzhou/zhjy_config_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-智慧经营-各项配置-详情
export function yzJYConfigDetail(data) {
  return request({
    url: "/yunzhou/zhjy_config_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 智慧物业
// 云州-智慧物业-能耗概括-新增
export function yzZhwyEnergyAdd(data) {
  return request({
    url: "/yunzhou/zhwy_energy_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-能耗概括-编辑
export function yzZhwyEnergyEdit(data) {
  return request({
    url: "/yunzhou/zhwy_energy_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-能耗概括-删除
export function yzZhwyEnergyDel(data) {
  return request({
    url: "/yunzhou/zhwy_energy_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-能耗概括-详情
export function yzZhwyEnergyDetail(data) {
  return request({
    url: "/yunzhou/zhwy_energy_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-能耗概括-列表
export function yzZhwyEnergyList(data) {
  return request({
    url: "/yunzhou/zhwy_energy_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-智慧物业-值班人员-新增
export function yzZhwyDutyAdd(data) {
  return request({
    url: "/yunzhou/zhwy_duty_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-值班人员-编辑
export function yzZhwyDutyEdit(data) {
  return request({
    url: "/yunzhou/zhwy_duty_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-值班人员-删除
export function yzZhwyDutyDel(data) {
  return request({
    url: "/yunzhou/zhwy_duty_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-值班人员-详情
export function yzZhwyDutyDetail(data) {
  return request({
    url: "/yunzhou/zhwy_duty_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-智慧物业-值班人员-分页列表
export function yzZhwyDutyList(data) {
  return request({
    url: "/yunzhou/zhwy_duty_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 云州-园区党建-各项配置-编辑
export function yzYqdjConfigEdit(data) {
  return request({
    url: "/yunzhou/yqdj_config_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党建-各项配置-详情
export function yzYqdjConfigDetail(data) {
  return request({
    url: "/yunzhou/yqdj_config_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}




// 云州-园区党群-青年风采-添加
export function yzYqdjYouthAdd(data) {
  return request({
    url: "/yunzhou/excellenty_youth_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-青年风采-删除
export function yzYqdjYouthDel(data) {
  return request({
    url: "/yunzhou/excellenty_youth_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-青年风采-修改
export function yzYqdjYouthEdit(data) {
  return request({
    url: "/yunzhou/excellenty_youth_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-青年风采-详情
export function yzYqdjYouthDetail(data) {
  return request({
    url: "/yunzhou/excellenty_youth_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-青年风采-列表
export function yzYqdjYouthList(data) {
  return request({
    url: "/yunzhou/excellenty_youth_list",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 云州-园区党群-政策列表-添加
export function yzYqdjPolicyAdd(data) {
  return request({
    url: "/yunzhou/party_policy_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-政策列表-删除
export function yzYqdjPolicyDel(data) {
  return request({
    url: "/yunzhou/party_policy_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-政策列表-修改
export function yzYqdjPolicyEdit(data) {
  return request({
    url: "/yunzhou/party_policy_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-政策列表-详情
export function yzYqdjPolicyDetail(data) {
  return request({
    url: "/yunzhou/party_policy_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 云州-园区党群-政策列表-列表
export function yzYqdjPolicyList(data) {
  return request({
    url: "/yunzhou/party_policy_list",
    method: "post",
    data: Qs.stringify(data),
  });
}






